import React from "react";

const AccountSettings = ({ settings, handleChange }) => {
  return (
    <div>
      <h3 className="text-lg font-medium mb-4">Account Settings</h3>
      
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-1">Full Name</label>
        <input 
          type="text"
          className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
          value={settings.account.fullName}
          onChange={(e) => handleChange("account", "fullName", e.target.value)}
        />
      </div>
      
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
        <input 
          type="email"
          className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
          value={settings.account.email}
          onChange={(e) => handleChange("account", "email", e.target.value)}
          disabled
        />
        <p className="text-xs text-gray-500 mt-1">Contact admin to change email</p>
      </div>
      
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number</label>
        <input 
          type="tel"
          className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
          value={settings.account.phone}
          onChange={(e) => handleChange("account", "phone", e.target.value)}
        />
      </div>
      
      {/* <div className="flex items-center mb-4">
        <input
          id="notifications"
          type="checkbox"
          className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
          checked={settings.account.notificationsEnabled}
          onChange={(e) => handleChange("account", "notificationsEnabled", e.target.checked)}
        />
        <label htmlFor="notifications" className="ml-2 block text-sm">
          Enable Notifications
        </label>
      </div> */}
      
      {/* <p className="text-xs text-gray-500 mt-4 italic">
        Note: Account settings changes will be saved via backend API integration (not implemented in this demo).
      </p> */}
    </div>
  );
};

export default AccountSettings; 